var cilSquare = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M476,16H36A20.023,20.023,0,0,0,16,36V476a20.023,20.023,0,0,0,20,20H476a20.023,20.023,0,0,0,20-20V36A20.023,20.023,0,0,0,476,16ZM464,464H48V48H464Z' class='ci-primary'/>"];

export { cilSquare };

